import { useFlightSearchResults } from '@pages/FlightSearchResult/contexts/FlightSearchResultsContext';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { webEngageTrackFlightSearch } from '@helpers/webEngage';

import { getCurrentSiteState, getLocaleState } from '@redux/selectors';

const useFlightSearchWebEngageTracking = () => {
  const [isWebEngageTracked, setIsWebEngageTracked] = useState<boolean>(false);

  const { search } = useFlightSearchResults();
  const locale = useSelector(getLocaleState);
  const currentSite = useSelector(getCurrentSiteState);

  useEffect(() => {
    if (!isWebEngageTracked && !!search?.id) {
      const { legs, adultsCount, childrenCount, infantsCount, cabin } = search;

      webEngageTrackFlightSearch(
        currentSite.countryCode,
        locale,
        adultsCount,
        childrenCount,
        infantsCount,
        cabin,
        legs,
      );
      setIsWebEngageTracked(true);
    }
  }, [currentSite.countryCode, search, isWebEngageTracked, locale]);
};

export default useFlightSearchWebEngageTracking;
